import React from 'react';
import AoLovesMobileWrapper from './MobileViewWrapper/AoLovesMobileWrapper';
import Wrapper from './MobileViewWrapper/Wrapper';

const ProductCardMobileView = ({ index, product }) => {
	const showFeaturedProduct = index === 0 && product.IsFeaturedProduct;

	return showFeaturedProduct ? (
		<AoLovesMobileWrapper {...{ product, index }} />
	) : (
		<Wrapper {...{ product, index }} />
	);
};

export default ProductCardMobileView;
